import React from 'react';
import SocialShares from './SocialShares'

function Footer(props) {
    return (
        <div>
            <SocialShares />
            <div className="footer">
                <div className="disclaimer">
                    Paid for by DCCC · 430 S. Capitol Street, S.E. Washington, D.C. 20003 · 202-863-1500
                    <br/> Not authorized by any candidate or candidate's committee.
                </div>
                Photos are derivatives of works by <a href="https://www.flickr.com/photos/miller_center/18134533381" target="_blank" rel="noopener noreferrer">Miller Center</a> (<a href="https://creativecommons.org/licenses/by/2.0/" target="_blank" rel="noopener noreferrer">CC BY 2.0.</a>) and <a href="https://www.flickr.com/photos/publiccitizen/6831954689" target="_blank" rel="noopener noreferrer">Public Citizen</a> (<a href="https://creativecommons.org/licenses/by-nc-sa/2.0/" target="_blank" rel="noopener noreferrer">CC BY-NC-SA 2.0</a>).
            </div>
        </div>
    )
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js